import React from 'react';
import { connect, useSelector } from 'react-redux';
import { updateEpikBox } from '../../../actions/EpikBoxes';
import './ReportListTable.css';
const isGranitenetEmail = email =>
  typeof email === 'string' && email.toLowerCase().endsWith('@granitenet.com');
const isCustomerAdmin = user =>
  user?.role === 'admin' && user?.permissionsGroup === 'Customer';
const canAccessInternalOnlyAsCustomerAdmin = user =>
  isCustomerAdmin(user) && isGranitenetEmail(user?.email);
const INTERNAL_ONLY_SYMBOLS = ['PAR', 'SIM', 'BLR'];
const ENGINEERING_SYMBOLS = ['BLR', 'INT', 'AFR', 'NSR', 'BOL', 'BAD', 'UTR'];

const ReportListRow = ({ report, onBoxClick }) => {
  const user = useSelector(state => state.AppState.user);
  const customerAdmin = isCustomerAdmin(user);
  const allowInternalForCustomerAdmin = canAccessInternalOnlyAsCustomerAdmin(user);
  const allowedAssetsReportRoles = ['superAdmin', 'companyGroupAdmin'];
  const symbol = report?.reportSymbol;
  const isInternalOnly = INTERNAL_ONLY_SYMBOLS.includes(symbol);
  if (customerAdmin) {
    if (isInternalOnly && !allowInternalForCustomerAdmin) {
      return null;
    }
  } else {
    if (ENGINEERING_SYMBOLS.includes(symbol) && !user?.epikEngineering) {
      return null;
    }
  // Ensure Customer permissions group doesn't have access to internal reports
    if (['PAR', 'SIM'].includes(symbol) && !allowedAssetsReportRoles.includes(user?.role)) {
    return null;
  }

  if (['PAR', 'SIM'].includes(symbol) && user?.permissionsGroup === 'Customer') {
    return null;
  }
  if (symbol === 'OOBM_TTY' && !allowedAssetsReportRoles.includes(user?.role)) {
    return null;
    }
  }

  const fieldClicked = () => {
    onBoxClick(report);
  };

  return (
    <tr className="row-hover">
      <td onClick={fieldClicked} className="report-col report-name-cell">
        <span>{report.reportName || ''}</span>
        {/* {report.isInternal && (
          <span className="internal-label">
            INTERNAL
          </span>
        )} */}
      </td>
      <td className="description-col">
        <p className="description-text">{report.description}</p>
      </td>
      <td>{report.owner}</td>
      {user.permissionsGroup !== "Customer" && (
        <td>
          {report.isInternal ? (
            <span className="internal-label">Internal Only</span>
          ) : (
            'Customer Facing'
          )}
        </td>
)}
    </tr>
  );
};

const mapDispatchToProps = dispatch => ({
  updateBox: (token, report) => dispatch(updateEpikBox(token, report)),
});

export default connect(
  null,
  mapDispatchToProps,
)(ReportListRow);
